// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type MentionIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from mention.svg
 */
export default function MentionIcon(props: MentionIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="MentionIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8.195 16q-1.95 0-3.47-.53-1.522-.523-2.574-1.54-1.05-1.01-1.601-2.47T0 8.137q0-1.838.55-3.335.555-1.497 1.62-2.568Q3.232 1.156 4.767.578 6.307 0 8.275 0q1.821 0 3.251.53 1.436.529 2.433 1.509a6.4 6.4 0 0 1 1.521 2.319q.526 1.338.52 2.963a9.5 9.5 0 0 1-.196 2.057 5.1 5.1 0 0 1-.635 1.638q-.428.694-1.125 1.101-.697.402-1.687.457-.708.055-1.149-.104-.44-.158-.672-.469a1.7 1.7 0 0 1-.293-.736h-.074q-.146.366-.574.663a3.4 3.4 0 0 1-1.045.457 4.2 4.2 0 0 1-1.302.116 3.9 3.9 0 0 1-1.369-.335 3.5 3.5 0 0 1-1.143-.846q-.495-.554-.782-1.37-.28-.815-.287-1.886.006-1.058.3-1.844.299-.786.788-1.32.494-.537 1.1-.84a3.9 3.9 0 0 1 1.216-.39q.69-.105 1.308 0 .617.103 1.039.335.427.23.531.499h.086v-.682h1.913v5.94q.006.42.19.651a.6.6 0 0 0 .494.231q.423 0 .703-.37.287-.372.428-1.139.147-.766.147-1.954 0-1.144-.306-2.008-.3-.87-.843-1.479a4.4 4.4 0 0 0-1.253-.998 5.8 5.8 0 0 0-1.552-.56 8.2 8.2 0 0 0-1.712-.176q-1.521 0-2.658.462-1.137.458-1.895 1.284a5.4 5.4 0 0 0-1.136 1.942 7.7 7.7 0 0 0-.38 2.416q.008 1.442.404 2.556.403 1.108 1.186 1.862.782.755 1.93 1.145 1.15.39 2.641.389.703 0 1.375-.104.672-.097 1.216-.243.544-.14.874-.274l.605 1.765q-.385.219-1.045.408-.654.195-1.479.31Q9.063 16 8.195 16m-.28-5.502q.745 0 1.185-.286.446-.285.636-.846.195-.566.183-1.393-.006-.731-.19-1.236a1.4 1.4 0 0 0-.617-.773q-.434-.267-1.21-.268-.678 0-1.155.287a1.87 1.87 0 0 0-.721.803q-.245.51-.25 1.205.005.645.207 1.223.202.573.666.931.465.354 1.265.353"
        />
      </g>
    </svg>
  );
}
